import React from "react";
import PropTypes from "prop-types";
import "./CategoryCard.css";
import pepeIcon from "../assets/pepe-icon.png";
const CategoryCard = ({
  title,
  description,
  gradient,
  timer,

  onPlaceBet,
}) => {
  const getCardDescription = (title) => {
    switch (title.toLowerCase()) {
      case "market cap":
        return "Watch the highest market cap coins go head-to-head in a thrilling race!";
      case "alt coins":
        return "Join a race featuring the best-performing altcoins in the market!";
      case "meme":
        return "Epic races with the most viral and unpredictable meme coins!";
      case "defi":
        return "Compete with the top DeFi tokens in this decentralized finance race!";
      default:
        return description;
    }
  };

  return (
    <div className={`category-card-${gradient} rounded-xl p-4 relative`}>
      <div className="z-10 relative">
        <div className="">
          <div className="flex">
            <div className="flex flex-col">
              <div className="font-bold mt-2">
                <h3>{title}</h3>
              </div>
              <p className="mb-6 text-sm mt-2">{getCardDescription(title)}</p>
            </div>
            {title?.toLowerCase() === 'memecoins' && <img
              src={pepeIcon}
              alt="pepeIcon"
              className="w-20 h-20 mt-2"
            />}
          </div>
          <div className="flex flex-col items-center gap-3">
            <div className="divider"> </div>
            <div className="flex gap-3">
              <div className="time-unit">
                <span className="time-value">{timer.hours}</span>
                <span className="text-xs mt-1.5">Hours</span>
              </div>
              <div className="time-unit">
                <span className="time-value">{timer.minutes}</span>
                <span className="text-xs mt-1.5">Minutes</span>
              </div>
              <div className="time-unit">
                <span className="time-value">{timer.seconds}</span>
                <span className="text-xs mt-1.5">Seconds</span>
              </div>
            </div>
            <div className="divider"> </div>

            <button className="w-full bg-white hover:opacity-80 rounded-xl mt-2" onClick={onPlaceBet}>
              Place Bet
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

CategoryCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  gradient: PropTypes.string.isRequired,
  icon: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)])
    .isRequired,
  timer: PropTypes.shape({
    hours: PropTypes.string.isRequired,
    minutes: PropTypes.string.isRequired,
    seconds: PropTypes.string.isRequired,
  }).isRequired,
  stats: PropTypes.shape({
    totalPools: PropTypes.number,
    activeRaces: PropTypes.number,
    totalVolume: PropTypes.number,
  }),
  onPlaceBet: PropTypes.func.isRequired,
};

export default CategoryCard;
